import * as THREE from 'three';

/**
 * Checks if the given object is a THREE.BufferGeometry instance.
 */
export const isOrthographicCamera = (object: unknown): object is THREE.OrthographicCamera => {
  return !!(object && (object as THREE.OrthographicCamera).isOrthographicCamera);
};
